// Écran de gestion des fournisseurs (racine 401).
import React from "react";
import TiersManager from "@/components/TiersManager";

export default function Fournisseurs() {
  return <TiersManager type="fournisseur" titre="Fournisseurs" libelleSingulier="fournisseur" />;
}
